import { Route, Routes } from 'react-router-dom'

import { contractPipelineDetailsRoutes } from './routes'
import General from '../General/General'

const ContractPipelineDetailsRouter = () => (
  <Routes>
    {contractPipelineDetailsRoutes.map((route) => (
      <Route key={route.path} path={route.path} element={<route.component />} />
    ))}
    <Route index element={<General />} />
  </Routes>
)

export default ContractPipelineDetailsRouter
